import { Text } from '@kerfjs/ui/text';
import type { SafeHtml } from 'kerfjs';

export function SavingsMethodNote({ method }: { method: string }): SafeHtml {
  return (
    <Text tone="quiet" size="compact" class="savings-method-note method-note">
      {method}
    </Text>
  );
}
